import { atom } from "jotai";

export const inFlightSavesCountAtom = atom<number>(0);

export const areAnySavesInFlightAtom = atom((get) => get(inFlightSavesCountAtom) > 0);

export const incrementInFlightSavesCountAtom = atom(null, (get, set) => {
  set(inFlightSavesCountAtom, get(inFlightSavesCountAtom) + 1);
});

export const decrementInFlightSavesCountAtom = atom(null, (get, set) => {
  set(inFlightSavesCountAtom, get(inFlightSavesCountAtom) - 1);
});
